import type { Note } from "@/core/types";

export function getNoteIcon(note: Note): string {
  if (note.version === 3 || note.version === 4 || note.version === 5) {
    return "care-note-icon.svg";
  }
  if (note.version === 6 || note.version === 7) {
    return "cm-note.jpg";
  }
  if (note.provider_type?.startsWith("PRESCRIBE")) {
    return "prescriber-note-icon.svg";
  }

  return "bhs-note-icon.svg";
}
